import React from "react";
import * as theme from "../theme";
import Typography from "@material-ui/core/Typography";

export default function RegularGreyText({
  text,
  lineheight = 1.5,
  fontSize = theme.ResponsiveRegularFontSize,
}) {
  return (
    <div>
      <Typography
        style={{
          color: "grey",
          fontFamily: "GibsonRegular",
          fontSize: fontSize,
          lineHeight: lineheight,
        }}
      >
        {text}
      </Typography>
    </div>
  );
}
